import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useNativePaymentMethodsContext } from '@/donationPages/_dependencies/NativePaymentMethods';
function useDelayLoadingNativePaymentMethod() {
  const $ = _c(3);
  const {
    loading
  } = useNativePaymentMethodsContext();
  const [nativeLoading, setNativeLoading] = useState(true);
  let t0;
  let t1;
  if ($[0] !== loading) {
    t0 = () => {
      const timeout = setTimeout(() => {
        setNativeLoading(loading);
      }, 1);
      return () => clearTimeout(timeout);
    };
    t1 = [loading];
    $[0] = loading;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return nativeLoading;
}
export default useDelayLoadingNativePaymentMethod;